import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageChannelService, BnLoadingService, EntityPagedResult, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import { ROLE_GESTOR_CONSULTA } from 'src/app/constantes/permissao.constants';
import Utils from 'src/app/shared/fgi-utils';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { LimiteContratacao } from 'src/app/model/limite-agente-financeiro.model';

import { TarefasLimitesService } from './tarefas.limites.service';
import { OcorrenciaValidacaoVO } from 'src/app/shared/ocorrencia-validacao.vo';
import { ModalidadeGarantia } from '../../../model/modalidade_garantia.model';
import { ModalidadeGarantiaService } from '../../modalidade_garantia/modalidade-garantia.service';
import { TrancheService } from 'src/app/shared/services/tranche.service';
import { LimiteContratacaoBeneficiario, Tranche } from '../../../model/tranche.model';

@Component({
    selector: 'app-tarefas-limites',
    templateUrl: './tarefas-limites.component.html',
    styleUrls: ['./tarefas-limites.component.scss'],
    standalone: false
})
export class TarefasLimitesComponent implements OnInit {

  public cpfOuCnpjBeneficiario: string;
  public cnpjAgenteFinanceiro: string;
  public numeroTranche: number;
  public idOperacaoGarantida: number;

	public valorLimite: LimiteContratacao;

  constructor(
    private loadingService: BnLoadingService,
    private service: TarefasLimitesService,
    private messageService: MessageChannelService) {
  }

  ngOnInit() {
  }

  buscarLimiteBeneficiarioFg2() {
    this.loadingService.bloqueiaTela();

    this.service.buscarLimiteBeneficiarioFg2(this.cpfOuCnpjBeneficiario, this.cnpjAgenteFinanceiro, this.numeroTranche)
      .subscribe(limite => {
        this.valorLimite = limite;

        let msgLimites = 'Limite total: ' + this.valorLimite.valorLimiteTotal + '\r\n' +
                         'Limite utilizado: ' + this.valorLimite.valorLimiteUtilizado + '\r\n' +
                         'Limite disponivel: ' + this.valorLimite.valorLimiteDisponivel;

        this.messageService.addMessage({
          title: 'Sucesso',
          type: 'CRUD_OPERATION',
          level: messageLevel.SUCCESS,
          message: msgLimites
        });

        this.loadingService.liberaTela();
      }, (error) => {
        this.loadingService.liberaTela();
      });
  }

  buscarLimiteBeneficiarioFgiTradicional() {
    this.loadingService.bloqueiaTela();

    this.service.buscarLimiteBeneficiarioFgiTradicional(this.cpfOuCnpjBeneficiario, this.cnpjAgenteFinanceiro)
      .subscribe(limite => {
        this.valorLimite = limite; 
        
        let msgLimites = 'Limite utilizado no FGI Tradicional (sistema legado): ' + this.valorLimite.valorLimiteUtilizado;

        this.messageService.addMessage({
          title: 'Sucesso',
          type: 'CRUD_OPERATION',
          level: messageLevel.SUCCESS,
          message: msgLimites
        });

        this.loadingService.liberaTela();
      }, (error) => {
        this.loadingService.liberaTela();
      });
  }

  calcularLimiteExposicao() {
    this.loadingService.bloqueiaTela();

    this.service.calcularLimiteExposicao(this.idOperacaoGarantida)
      .subscribe(limite => {
          
        console.log(limite);

        let msgLimites = 'Valor do limite de exposicao calculado: ' + limite;

        this.messageService.addMessage({
          title: 'Sucesso',
          type: 'CRUD_OPERATION',
          level: messageLevel.SUCCESS,
          message: msgLimites
        });

        this.loadingService.liberaTela();
      }, (error) => {
        this.loadingService.liberaTela();
      });
  }
}